<template>
    <v-container fluid>
        <v-layout>
            <v-flex>
                <div class="display-3 text-xs-center">Bienvenido</div>
                <div class="display-2 text-xs-center">{{ userName }}</div>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
    import {mapGetters} from 'vuex'

    export default {
        data() {
            return {
                resultado: ''
            }
        },
        computed: {
            ...mapGetters('auth', ['userName'])
        },
        mounted() {
            setTimeout(() => {
                this.$router.push({name: 'dashboard'})
            }, 2000);
        },
        methods: {
            test() {
                this.$http.post('/test')
                    .then(r => {
                        this.resultado = r.data;
                    })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/pages/home.vue